// javascript
// app/javascript/components/TemplateFieldBuilder.vue


<template>
  <div class="space-y-3">
    <div class="flex gap-2">
      <button type="button" class="btn btn-sm" @click="addField">Add Field</button>
      <button type="button" class="btn btn-sm" @click="addSection">Add Section</button>
    </div>
    {{fields}}
    <div v-for="(f, idx) in fields" :key="idx" class="border rounded p-3 space-y-2">
      <TemplateField
          @update="onChanged"
          :field="f" :index="idx" @remove="removeField(idx)"/>
    </div>

    <input type="hidden" name="app_template[fields]" :value="serialized" />
  </div>
</template>

<style scoped>
/* optional styling tweaks */
</style>

<script setup>
import { reactive, computed } from "vue"
import TemplateField from "./TemplateField.vue";
import {buildField, buildSectionField} from "./FieldHelper";

const props = defineProps({
  initialFields: { type: Array, default: () => [] }
})
const emit = defineEmits(["update"])

const fields = reactive(props.initialFields.map(f => ({ ...f })))

function addField() {
  fields.push(buildField())
  emit("update", fields)
}
function onChanged() {
  emit("update", fields)
}
function addSection() {
  fields.push(buildSectionField())
  emit("update", fields)
}
function removeField(idx) {
  fields.splice(idx, 1)
  emit("update", fields)
}

const serialized = computed(() => JSON.stringify(fields))
</script>